<template>
  <table-layout tag="table" :class="['api-explorer-doc-table', 'text-xs']">
    <row tag="tr">
      <cell tag="th" v-for="(row, index) in th" :key="index" v-html="row" :class="['font-semibold', 'uppercase', 'p-3']" />
    </row>
    <row tag="tr" v-for="(value, key) in td" :key="key">
      <cell :class="['p-3']" tag="td">
        <code :class="['whitespace-nowrap']" v-html="key" />
      </cell>
      <cell v-for="(prop, i) in value" :key="i" :class="['p-3']" tag="td">
        <span :is="i === value.length - 1 ? 'span' : 'code'" :class="[i === value.length - 1 ? 'span' : 'code' ? null : 'whitespace-nowrap']" v-html="prop" />
      </cell>
    </row>
  </table-layout>
</template>
<script>
export default {
  name: 'ApiExplorerDocTable',
  props: {
    th: {
      type: Array,
      required: true,
      default: () => []
    },
    td: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>
<style>
.api-explorer-doc-table .bcq-table-layout-row
{
  border-bottom: solid 1px var(--semi-transparent-dark);
}

.bcq-ui-theme-dark .api-explorer-doc-table .bcq-table-layout-row
{
  border-bottom: solid 1px var(--semi-transparent-light);
}

.api-explorer-doc-table .bcq-table-layout-row:first-child
{
  border-bottom-width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/api-explorer/api-explorer-doc-table.vue